import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { getProfileNames } from "../../../reducers/profile.slice";
import { UserProfile } from "../../../types/UserProfile";

export const useProfileCreation = () => {
  const dispatch = useAppDispatch();
  const [validationMessage, setValidationMessage] = useState("");

  const validateProfileName = useCallback((name: string, country: string) => {
    if (!name.trim()) return "Profile name cannot be empty.";
    if (name.length < 3) return "Minimum profile name length is 3 letters.";
    if (!country) return "Please select country";
    return null;
  }, []);

  const checkDuplicateName = useCallback(
    async (name: string) => {
      const profiles = (await dispatch(
        getProfileNames()
      ).unwrap()) as UserProfile[];
      return profiles.some((profile) => profile.name === name);
    },
    [dispatch]
  );

  return {
    validateProfileName,
    checkDuplicateName,
    validationMessage,
    setValidationMessage,
  };
};
